const ACTIVE_CLASS = `task__item--opened`;

const collapseSubtasks = () => {
  const collapseBtnElements = document.querySelectorAll(`.js-subtask-collapse-btn`);

  if (collapseBtnElements.length) {
    function showCollapseBlock(collapseBlock) {
      collapseBlock.style.display = `block`;
    }

    function hideCollapseBlock(collapseBlock) {
      collapseBlock.style.display = `none`;
    }

    function onCollapseBtnElementClick(evt) {
      const selfElement = evt.currentTarget;
      // Нахождение текущего родителя элемента
      const currentParentElement = selfElement.closest(`.js-collapse-parent`);
      // Нахождение текущего списка подзадач
      const currentCollapseSublist = currentParentElement.querySelector(`.js-collapse-sublist`);

      currentParentElement.classList.toggle(ACTIVE_CLASS);

      // Проверка открыт ли текущий список подзадач
      if (currentParentElement.classList.contains(ACTIVE_CLASS)) {
        showCollapseBlock(currentCollapseSublist);
      } else {
        hideCollapseBlock(currentCollapseSublist);
      }
    }

    // Отслеживание клика по кнопкам раскрытия
    collapseBtnElements.forEach((collapseBtnElement) => collapseBtnElement.addEventListener(`click`, onCollapseBtnElementClick));
  }
};

export {collapseSubtasks};
